import { gql } from "@/__generated__/gql";

export const STOP_BULK_MESSAGE_MUTATION = gql(`
 mutation StopBulkMessage(
  $bulkMessageId: ID!
) {
  stopBulkMessageMutation(input: {
    bulkMessageId: $bulkMessageId
  }) {
    success
    errors {
      title
      message
    }
  }
}
`);
